/**
 * cc-atc-fix.js — ATC Fix + Fly Bubble + Cart Drawer
 */
(function () {
  'use strict';

  if (!document.getElementById('cc-fly-style')) {
    var style = document.createElement('style');
    style.id  = 'cc-fly-style';
    style.textContent = [
      '.cc-fly-item{position:fixed;width:52px;height:52px;border-radius:50%;overflow:hidden;',
      'border:2.5px solid #b54863;box-shadow:0 8px 28px rgba(181,72,99,.5);',
      'z-index:99999;pointer-events:none;background:#fce4ec;',
      'display:flex;align-items:center;justify-content:center;',
      'will-change:left,top,transform,opacity;}',
      '.cc-fly-item img{width:100%;height:100%;object-fit:cover;}',
      '#cc-toast-el{position:fixed;bottom:90px;left:50%;',
      'transform:translateX(-50%) translateY(16px);',
      'background:#1a1a1a;color:#fff;font-size:13px;font-weight:600;',
      'padding:10px 22px;border-radius:100px;',
      'opacity:0;transition:opacity .28s ease,transform .28s ease;',
      'z-index:99999;white-space:nowrap;pointer-events:none;',
      'font-family:"DM Sans",-apple-system,sans-serif;',
      'box-shadow:0 4px 20px rgba(0,0,0,0.2);}',
      '#cc-toast-el.show{opacity:1;transform:translateX(-50%) translateY(0);}',
      '@media(max-width:749px){#cc-toast-el{bottom:120px;font-size:12px;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function getToastEl() {
    var t = document.getElementById('cc-toast-el');
    if (!t) { t = document.createElement('div'); t.id = 'cc-toast-el'; document.body.appendChild(t); }
    return t;
  }

  function isMobile() { return window.innerWidth <= 768; }

  window.ccShowToast = function (msg) {
    var t = getToastEl();
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._tm);
    t._tm = setTimeout(function () { t.classList.remove('show'); }, 2800);
  };

  /* ── CART ICON POSITION
     header-actions.liquid se pata hai:
     cart-drawer-component > button[data-testid="cart-drawer-trigger"] > cart-icon > .svg-wrapper
     Bubble ko cart-icon ke SVG wrapper ke center par bhejna hai
  ── */
  window.ccGetCartPos = function () {
    /* Exact selector chain from header-actions.liquid */
    var el = document.querySelector('cart-drawer-component button[data-testid="cart-drawer-trigger"] cart-icon .svg-wrapper')
          || document.querySelector('cart-drawer-component button[data-testid="cart-drawer-trigger"] cart-icon')
          || document.querySelector('cart-drawer-component button[data-testid="cart-drawer-trigger"]')
          || document.querySelector('cart-drawer-component cart-icon .svg-wrapper')
          || document.querySelector('cart-icon .svg-wrapper')
          || document.querySelector('cart-icon');

    if (el) {
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) {
        return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
      }
    }

    /* Fallback — top right */
    return { x: window.innerWidth - 44, y: 28 };
  };

  /* ── FLY BUBBLE — 1600ms slow cubic arc ── */
  window.ccFlyToCart = function (imgSrc, sx, sy) {
    var dest = window.ccGetCartPos();
    var half = 26;
    var bubble = document.createElement('div');
    bubble.className  = 'cc-fly-item';
    bubble.style.left = (sx - half) + 'px';
    bubble.style.top  = (sy - half) + 'px';

    if (imgSrc) {
      var img = new Image();
      img.src = imgSrc;
      bubble.appendChild(img);
    } else {
      bubble.style.fontSize = '22px';
      bubble.textContent    = '\uD83D\uDED2';
    }
    document.body.appendChild(bubble);

    var t0 = null, dur = 1600;
    var bx = sx - half, by = sy - half;
    var dx = dest.x - half - bx;
    var dy = dest.y - half - by;

    function ease(t) { return t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t+2, 3)/2; }

    function step(ts) {
      if (!t0) t0 = ts;
      var p   = Math.min((ts - t0) / dur, 1);
      var e   = ease(p);
      var arc = Math.sin(p * Math.PI) * -170;
      bubble.style.left      = (bx + dx * e) + 'px';
      bubble.style.top       = (by + dy * e + arc) + 'px';
      bubble.style.transform = 'scale(' + Math.max(0.05, 1 - p * 0.80) + ')';
      bubble.style.opacity   = p > 0.78 ? String(Math.max(0, (1-p)/0.22)) : '1';
      if (p < 1) requestAnimationFrame(step);
      else if (bubble.parentNode) bubble.parentNode.removeChild(bubble);
    }
    requestAnimationFrame(step);
  };

  /* ── CART COUNT ── */
  function updateCartCount(count) {
    var s = count > 0 ? String(count) : '';
    document.querySelectorAll('.cart-bubble__text-count').forEach(function(el) { el.textContent = s; });
    document.querySelectorAll('cart-icon').forEach(function(el) {
      count > 0 ? el.classList.add('header-actions__cart-icon--has-cart') : el.classList.remove('header-actions__cart-icon--has-cart');
    });
    document.querySelectorAll('.cart-bubble').forEach(function(el) {
      if (count > 0) { el.removeAttribute('hidden'); el.classList.remove('visually-hidden','hidden'); }
    });
  }

  /* ── OPEN DRAWER — 1400ms delay ── */
  function openCartDrawer() {
    if (isMobile()) return;
    setTimeout(function () {
      var d = document.querySelector('cart-drawer-component');
      if (!d) return;
      if (typeof d.open === 'function') { d.open(); return; }
      var btn = d.querySelector('[data-testid="cart-drawer-trigger"]');
      if (btn) btn.click();
    }, 1400);
  }

  window.ccCartRefresh = function (opts) {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count || 0);
        if (opts && opts.openDrawer) openCartDrawer();
      }).catch(function() {});
  };

  function refreshCartDrawer(sectionsData) {
    if (!sectionsData) return;
    Object.keys(sectionsData).forEach(function(id) {
      var html = sectionsData[id]; if (!html) return;
      var comp = document.querySelector('cart-items-component[data-section-id="' + id + '"]'); if (!comp) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newComp = doc.querySelector('cart-items-component[data-section-id="' + id + '"]');
      if (newComp) {
        comp.innerHTML = newComp.innerHTML;
        var dialog = document.querySelector('.cart-drawer__dialog');
        if (dialog) dialog.classList.remove('cart-drawer--empty');
      }
    });
  }

  /* ── PRODUCT PAGE ATC ── */
  window.ccAddToCart = function (btn) {
    if (!btn || btn._busy) return;
    btn._busy = true;
    var variantId = document.getElementById('ccVariantId');
    var qtyInput  = document.getElementById('ccQtyInput');
    if (!variantId) { btn._busy = false; return; }
    var vid = parseInt(variantId.value);
    var qty = parseInt((qtyInput && qtyInput.value) || 1) || 1;
    var origHTML = btn.innerHTML;
    btn.innerHTML = '\u2713 Added!'; btn.style.background = 'linear-gradient(135deg,#2e7d32 0%,#1b5e20 100%)'; btn.disabled = true;
    var sectionIds = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el) {
      var s = el.getAttribute('data-section-id');
      if (s && sectionIds.indexOf(s) === -1) sectionIds.push(s);
    });
    var payload = { id: vid, quantity: qty };
    /* Bundle mein chune hue shades line item par likhe jate hain (product page
       ye function deta hai). Na ho to payload waisa hi rehta hai. */
    try {
      var props = window.ccCartProperties && window.ccCartProperties();
      if (props) payload.properties = props;
    } catch (e) {}
    if (sectionIds.length) payload.sections = sectionIds;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status && data.status !== 200) throw new Error(data.description || 'error');
      var imgUrl = data.featured_image && data.featured_image.url ? data.featured_image.url : '';
      var rb = btn.getBoundingClientRect();
      window.ccFlyToCart(imgUrl, rb.left + rb.width/2, rb.top + rb.height/2);
      window.ccShowToast('\u2713 Added to cart');
      if (data.sections) refreshCartDrawer(data.sections);
      fetch('/cart.js', { cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateCartCount(cart.item_count || 0);
          openCartDrawer();
          var msg = document.getElementById('ccShipMsg'), fill = document.getElementById('ccShipFill');
          if (msg && fill) {
            var thr = 300000, needed = thr - (cart.total_price || 0);
            if (needed <= 0) { msg.innerHTML = '\uD83C\uDF89 You get free delivery!'; fill.style.width = '100%'; }
            else { msg.innerHTML = 'Rs. <span>' + Math.ceil(needed/100).toLocaleString() + '</span> aur add karo \u2014 Free Delivery!'; fill.style.width = Math.min(99, Math.round(((cart.total_price||0)/thr)*100)) + '%'; }
          }
        }).catch(function() {});
      setTimeout(function() { btn.innerHTML = origHTML; btn.style.background = ''; btn.disabled = false; btn._busy = false; }, 2000);
    })
    .catch(function(err) {
      console.warn('[ccATC]', err);
      btn.innerHTML = origHTML; btn.style.background = ''; btn.disabled = false; btn._busy = false;
    });
  };

  document.addEventListener('cart:add', function() {
    setTimeout(function() { fetch('/cart.js',{cache:'no-store'}).then(function(r){return r.json();}).then(function(c){updateCartCount(c.item_count||0);}).catch(function(){}); }, 300);
  });
  document.addEventListener('cart:update', function() {
    setTimeout(function() { fetch('/cart.js',{cache:'no-store'}).then(function(r){return r.json();}).then(function(c){updateCartCount(c.item_count||0);}).catch(function(){}); }, 200);
  });

})();
